<template>
	<div style="padding-top: 85px;">
		<headerList></headerList>
		
		<div class="detail-box">
			<!-- 详情版心主要内容 -->
			<div  class="detail-main">
				<div class="ptb-15 flex flex-y- flex-x-s f-14 c-66">
					<span>当前位置: </span>
					<span class="ml-5">主页</span>
					<span class="iconfont iconxiangyoujiantou mlr-5"></span>
					<span>搜索</span>
					<span class="iconfont iconxiangyoujiantou mlr-5"></span>
					<span>{{q}}</span>
				</div>
				
				<div class="flex flex-y-s">
					<!-- 左侧内容 -->
					<div>
						<ul class="news_list_box bg-ff plr-40 ptb-20">
							<li class="pt-20 pb-15 news_detail b-b" v-for="item,index in new_list" @click="enterDetail(item.docId,item.doclibId)" :key="item.docId" >
								<div class="flex" style="">
									<img class="mr-20 radius-5" :src="item.COVERPATH" alt="" v-show="item.COVERPATH">
									<div class="flex-box flex-dir-col flex-x-b flex-y-s">
										<p class="bold f-20 c-00 onelist">{{item.SYS_TOPIC}}</p>
										<p class=" f-14 c-88" style="color: #4095cc;">{{item.doclibName}}</p>
										<div class="onelist text f-14 c-88">{{item.REMARK}}</div>
										<div class="flex flex-x-s f-14 c-99">
											<span class="iconfont iconview"></span>
											<span class="ml-5 f-12">{{item.CLICK_COUNT?item.CLICK_COUNT:0}}</span>
										</div>
									</div>
								</div>
							</li>
						</ul>
						<div class="bg-ff flex-c pb-30">
							<Page class-name="page-class" :total="total" :page-size="10" @on-change="changePage" />
						</div>
					</div>
					<!-- 右侧内容 -->
					<div class="right_content">
						<!-- 热门模板 -->
						<div class="news_like bg-ff">
							<div class="title plr-30 flex flex-x-s"> <span class="f-18 c-29 ml-10">热门模板</span></div>
							<ul class=" over">
								<li class="news_like_detail p-10 b-t flex" v-for="item,index in hot_list" v-show="index < 5" @click="enterDetail(item.docId,item.doclibId)">
									<img :src="item.COVERPATH" alt="" class="mr-10 radius-5" />
									<div class="flex-box">
										<p class="f-16 c-33 onelist">{{item.SYS_TOPIC}}</p>
										<div class="flex flex-x-s f-14 c-99 mt-10">
											<p>{{item.date}}</p>
											<p class="ml-10">浏览量 {{item.CLICK_COUNT?item.CLICK_COUNT:0}}</p>
										</div>
									</div>
								</li>
							</ul>
						</div>
						<!-- 热门图片 -->
						<div class="news_like bg-ff mt-20">
							<div class="title plr-30 flex flex-x-s b-b"> <span class="f-18 c-29 ml-10">相关搜索</span></div>
							<ul class="p-15 over flex flex-x-s flex-wrap">
								<li class="mb-10 mr-15 f-16 c-33 key_text"  @click="enterSearch('KEYWORDS_s',item)"   v-for="item in search_key" :key="item">{{item}}</li>
							</ul>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		<footer-view></footer-view>
	</div>
</template>

<script>
import footerView from './footer.vue'
import headerList from './header_nav.vue'
export default {
  data () {
    return {
			new_list: [], // 新闻列表
			hot_list: [], // 新闻列表_排行榜
			search_key: [],
			total:0,
			field:'',
			q:''
		}
  },
	
	components: {
		headerList,
		footerView
	},

  created () {
		let _this = this
		
		_this.field = _this.$route.query.field
		_this.q = _this.$route.query.q
		
	},
	
	mounted () {
		this.getnewsinfo()
		this.bindSearch()
		this.getimgLike()
	},

  methods: {

		 // 跳转到图片详情
		 toImgdetail (id,tid) {
		 	this.$router.push({path: '/img_detail', query: {id,tid}})
		 },
		 
		 // 获取列表
		 async getnewsinfo (page=0) {
		 	let _this = this
			_this.$Spin.show()
		 	let data = { 
		 				field: _this.field,
		 				q: _this.q,
		 				size: 10,
						page,
						sld:'AHSCXB',
						sort:'SYS_LASTMODIFIED_dt,desc'
		 			}
		 	const res = await _this.get_res('/search', data )
		 	// res.content.forEach( x => {
		 	// 	x.date = _this.util.formatDate(x.XINWENZIXUN_PUB_DATE)
		 	// 	x.year = x.date.substr(0,4)
		 	// 	x.mon = x.date.substr(5,2)
		 	// 	x.day = x.date.substr(8,2)
		 	// })
		 		 _this.new_list = res.content
		 		 _this.total = res.totalElements
		 		 _this.$Spin.hide()
		 },
		 
		 // 改变页码获取对应数据
		 changePage (old) {
			 this.getnewsinfo(old - 1)
		 },

		 
		 // 获取图片排行
		 async getimgLike () {
			 let _this = this
			 const res = await _this.get_res('/search?size=5&page=0&sld=AHSCXB&sort=CLICK_1_0_l,desc')
			 res.content.forEach( x => {
				 x.date = x.SYS_CREATED.substr(0,11)
			 })
			 _this.hot_list = res.content.reverse()
		 },
		 
		 // 获取关键字
		 async bindSearch () {
				 let _this = this
				 const res = await _this.get_res('/search/getHotWords',{size:5,sld: "AHSCXB"})
				 if (res.length) {
					 _this.search_key = res
				 }
		 },
		 
		 // 进入搜索页面
		 enterSearch (field,q) {
		 	this.$router.push({path: '/search_list',query:{field,q}})
		 },
		 
		 // 跳转
		 enterDetail (id,tid) {
		 	if (tid == 25 || tid == 837) {
				this.$router.push({path:'/img_detail',query: {id,tid}})
			} else if (tid == 28) {
				this.$router.push({path:'/audio_detail',query: {id,tid}})
			} else {
				this.$router.push({path:'/video_detail',query: {id,tid}})
			}
		 },
		 
	},
	
	// 监听器监听路由的变化
	watch: {
		'$route'(to,from) {
			let _this = this
			_this.field = _this.$route.query.field
			_this.q = _this.$route.query.q
			// 做一些路由变化的响应
			this.getnewsinfo(0)
		}
	},
	

}
</script>

<style lang="less" scoped>
	
	.detail-box {
		background-color: #f1f2f6;
		padding-bottom: 120px;
		
	}
	.detail-main {
		width: 1200px;
		margin: 0 auto;
	}
	.iconxiangyoujiantou {
		font-size: 12px;
		color: #666;
	}
	
	// 新闻列表
	.news_list_box {
		width: 800px;
		margin-bottom: 0!important;
		.news_detail {
			// height: 150px;
			cursor: pointer;
		}
		img {
			// width: 150px;
			height: 120px;
		}
		.flex-dir-col {
			height: 120px;
		}

	}
	
	// 右侧内容
	.right_content {
		width: 380px;
	}
	.news_like {
		.title {
			height: 48px;
		}
		.title::before {
			content: '';
			height: 16px;
			width: 2px;
			background-color: #0e0963;
		}
	}
	.news_like_detail {
		cursor: pointer;
		img {width: 110px;height: auto;}
	}
	.key_text {
		text-decoration: underline;
		cursor: pointer;
	}
</style>
